import { PromptInputAttachment, PromptInputAttachments, usePromptInputAttachments } from '@/ai-elements/prompt-input';
import { ChatInputState } from '@brandclub/bc-widgets';
import React, { useEffect } from 'react';

interface AttachmentsRowProps {
  onAttachmentsChange: (hasAttachments: boolean) => void;
  styles: ChatInputState;
}

export const AttachmentsRow: React.FC<AttachmentsRowProps> = ({ onAttachmentsChange, styles }) => {
  const attachments = usePromptInputAttachments();

  useEffect(() => {
    onAttachmentsChange(attachments.files.length > 0);
  }, [attachments.files.length, onAttachmentsChange]);

  if (attachments.files.length === 0) {
    return null;
  }

  return (
    <div
      style={{ paddingLeft: styles.paddingX, paddingRight: styles.paddingX, paddingTop: styles.paddingY }}
      className="tw:flex tw:flex-row tw:flex-wrap tw:gap-1"
    >
      <PromptInputAttachments>{(attachment) => <PromptInputAttachment data={attachment} />}</PromptInputAttachments>
    </div>
  );
};
